import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface RoleBasedRouteProps {
    allowedRoles: string[];
    children?: React.ReactNode;
}

const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({ allowedRoles, children }) => {
    const userRole = localStorage.getItem('user_role');
    
    console.log('RoleBasedRoute:', { userRole, allowedRoles });
    
    if (!userRole) {
        console.log('No user role found, redirecting to login');
        // Remember where they were headed so login can return them there.
        // Without this a Stripe success_url landing on a gated route lost its
        // query params (ds_session) to the /dashboard default — a real $999
        // payment read as "no charge". Post-login routing consumes this key.
        try {
            sessionStorage.setItem('aa_return_to', window.location.pathname + window.location.search);
        } catch { /* storage unavailable — login falls back to the default */ }
        return <Navigate to="/login" replace />;
    }

    if (!allowedRoles.includes(userRole)) {
        console.log('User role not allowed, redirecting to dashboard');
        
        // Redirect to the appropriate dashboard based on user role.
        // E2: the 'expert' branch is gone. Expert is a FLAG on a member
        // (is_expert), never a login role, so nothing can arrive here holding
        // it; the branch pointed at /expert, which itself only redirected to
        // /dashboard.
        // Each staff role has its OWN home, and they must be named separately:
        // a super sent to the consultant home lands on a route that redirects
        // into the partner console, which is gated against them, which sends
        // them back — a loop that renders as a blank page.
        if (userRole === 'super') {
            return <Navigate to="/super/business/overview" replace />;
        } else if (userRole === 'consultant') {
            return <Navigate to="/partner/clients" replace />;
        } else if (userRole === 'client' || userRole === 'client_admin') {
            return <Navigate to="/dashboard" replace />;
        }
        
        // Default fallback
        return <Navigate to="/" replace />;
    }

    console.log('Role check passed, rendering content');
    return children ? <>{children}</> : <Outlet />;
};

export default RoleBasedRoute; 